import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { Url } from '@wix/da-url';
const backendPageToReadableKeyMap = {
    dyw: 'watch',
    dd: 'dailyDeviations',
    rfy: 'home'
};
function findNewContentFor(key, mainNavNewContent) {
    return mainNavNewContent === null || mainNavNewContent === void 0 ? void 0 : mainNavNewContent.find(({ page })=>{
        var _backendPageToReadableKeyMap_page;
        return ((_backendPageToReadableKeyMap_page = backendPageToReadableKeyMap[page]) !== null && _backendPageToReadableKeyMap_page !== void 0 ? _backendPageToReadableKeyMap_page : page) === key;
    });
}
export function getDefaultMainNavigation() {
    const defaults = [
        {
            key: 'home',
            url: Url.browseHomeLink()
        },
        {
            key: 'watch',
            url: Url.browseDeviantsYouWatchLink(),
            restrictLoggedIn: true,
            pageType: 'watch'
        },
        {
            key: 'shop',
            url: Url.shopLink()
        },
        {
            key: 'dreamup',
            url: Url.dreamupLink()
        },
        {
            key: 'dailyDeviations',
            url: Url.browseDailyDeviationsLink(),
            restrictLoggedIn: true,
            pageType: 'daily-deviations'
        },
        {
            key: 'dailyChallenges',
            url: Url.dailyChallengesLink(),
            pageType: 'tag'
        },
        {
            key: 'topics',
            url: Url.browseTopicsLink(),
            pageType: 'topicList'
        },
        {
            key: 'popular',
            url: Url.browsePopularLink(),
            restrictLoggedIn: true
        }
    ];
    return defaults;
}
export function generateMainNavigation(mainNavNewContent) {
    return getDefaultMainNavigation().map((menuItem)=>{
        const newContent = findNewContentFor(menuItem.key, mainNavNewContent);
        if (!newContent) {
            return menuItem;
        }
        return _object_spread_props(_object_spread({}, menuItem), {
            url: newContent.url,
            hasNewContent: true,
            turnOffWithThisPageview: newContent.turnOffWithThisPageview
        });
    });
}
